<template>
  <div class="container login">
    <h1 class="logo">
      <img src="@/assets/img/logo1.svg" alt="impactus">
    </h1>
    <div class="content">
      <div class="wl">
        <div class="inner">
          <div class="box">
            <div class="title-group">
              <div class="tit">Welcome back</div>
              <div class="txt">{{t('message.loginPrompt')}}</div>
            </div>

            <div class="title-group-mo">
              <img src="@/assets/img/logo2.svg" alt="impactus">
              <div class="txt" v-html="t('message.impactusSafetyMessage')"></div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="tit">아이디(ID)</div>
                <InputText v-bind="InputId" :name="'memberId'" v-model="user.memberId"/>
              </div>
              <div class="row">
                <div class="tit">비밀번호(Password)</div>
                <InputText v-bind="InputPw" :name="'password'" v-model="user.password"/>
              </div>
              <div class="row tar">
                <linkTy1 v-bind="FindPassword" @click="onClickFindPassword"/>
              </div>
              <div class="row ty01">
                <buttonTy1 v-bind="LoginBtn" @click="validateAll"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="wr">
        <div class="inner">
          <div class="title-group">
            <img src="@/assets/img/logo2.svg" alt="impactus">
            <div class="txt">{{t('message.impactusSafetyMessage')}}</div>
          </div>
        </div>
      </div>
      <div class="foo-txt">All rights reserved. Copyright © 2025 FIDELITY SYSTEMS</div>
    </div>
  </div>
  <c-dialog v-model="dialogPasswordModel"
            v-bind="dialogPasswordBind"
            @close="dialogPasswordModel=false"
            @confirm="confirmPassword"
  />
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script lang="ts" setup>
import {ref, computed} from 'vue'
import { useForm } from "vee-validate";
import * as yup from "yup";
import { useAuthStore } from "@/store/auth";
import { storeToRefs } from 'pinia'
import AuthService from "@/services/auth.service";
import utils from "@/common/Utils"
import {useCommonStore} from "@/store/common";
import NativeBridge from "@/common/nativeBridge";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

console.log(import.meta.env.MODE)
//store
const authStore = useAuthStore()
const orgStoreRef = storeToRefs(useCommonStore())

//validation schema
const schema = yup.object().shape({
  memberId: yup.string().required(() => t('message.requiredField')),
  password: yup.string().required(() => t('message.requiredField')),
})
const { validate } = useForm({ validationSchema: schema })

//bind
const dialogPasswordModel = ref(false)
const user:any = ref({})
const snackbar = ref(false)
const snackText = ref('')

//ui
const InputId = computed(() => ({
  type: 'text',
  placeholder: '아이디(ID)'+t('message.enterValue'),
}))
const InputPw = computed(() => ({
  type: 'password',
  placeholder: '비밀번호(Password)'+t('message.enterValue'),
}))
const FindPassword = computed(() => ({
  linkText: '비밀번호 찾기(Forgot Password)',
  linkShow: true
}))
const LoginBtn = computed(() => ({
  btnText: '로그인(Login)',
  btnShow: true,
}))
const dialogPasswordBind = {
  dialogTit: t('message.password'),
  dialogText: t('message.passwordChangeConfirm'),
  btn1Text: t('message.confirm'),
  btn1Show: true,
  btn2Text: t('message.cancel'),
  btn2Show: true,
}

//hook
onMounted(()=>{
  NativeBridge.init()
  //5초는 user정보 기다려봄
  let time = 0
  const maxTime = 50
  const intervalId = setInterval(()=>{
    time++
    const user:any = JSON.parse(localStorage.getItem('user'))
    if(user?.memberIdx){
      clearInterval(intervalId)
      if (user.roles === 'ADMIN1')
        utils.movePage('/clientManagement')
      else if (user.roles === 'ADMIN2')
        utils.movePage('/groupManagement')
      else if (user.roles === 'ADMIN3' || user.roles === 'USER') {
        if (user.moduleCalender == "Y")
          utils.movePage('/safetyCalender')
        else if (user.moduleBbs == "Y")
          utils.movePage('/actionManagement')
        else if (user.moduleLeadership == "Y")
          utils.movePage('/safetyLeadership')
        else if (user.moduleReport == "Y")
          utils.movePage('/totalReport')
        else if (user.moduleBoard == "Y")
          utils.movePage('/myBoard')
        else
          utils.movePage('/empty')
      }
    }
    else if(time >= maxTime){
      clearInterval(intervalId)
    }
  }, 100)
})

//function
const validateAll = async () => {
  const result = await validate(); // 전체 필드 검증 실행
  if(result.valid)
    handleForm()
}

const handleForm=()=> {
  if(import.meta.env.MODE == 'development') {
    const tempUser = {
      clientIdx:0,
      clientName:'client',
      companyIdx:0,
      companyName:'company',
      memberId:"admin",
      memberName:"name",
      moduleBbs:"Y",
      moduleBoard:"Y",
      moduleCalender:"Y",
      moduleLeadership:"Y",
      moduleReport:"Y",
      roles:"ADMIN1"
    }
    localStorage.setItem('user', JSON.stringify(tempUser));
    localStorage.setItem('clientIdx', tempUser.clientIdx.toString());
    localStorage.setItem('clientName', tempUser.clientName);
    localStorage.setItem('companyIdx', tempUser.companyIdx.toString());
    localStorage.setItem('companyName', tempUser.companyName);
    utils.movePage('/clientManagement')
  }
  else {
    AuthService.login(user.value).then(
      (response:any) => {
        if(response) {
          //android
          if(window.mobileDevice) {
            try {
              window.mobileDevice.loggedIn(response.memberIdx, JSON.stringify(response))
            } catch(e) {
              utils.log(e)
            }
          } else if(window.webkit) {  //ios
            try {
              window.webkit.messageHandlers.scriptHandler.postMessage(response.memberIdx)
            } catch(e) {
              utils.log(e)
            }
          }

          orgStoreRef.user.value = response
          if (response.roles === 'ADMIN1')
            utils.movePage('/clientManagement')
          else if (response.roles === 'ADMIN2')
            utils.movePage('/groupManagement')
          else if (response.roles === 'ADMIN3' || response.roles === 'USER') {
            if(response.moduleCalender == "Y")
              utils.movePage('/safetyCalender')
            else if(response.moduleBbs == "Y")
              utils.movePage('/actionManagement')
            else if(response.moduleLeadership == "Y")
              utils.movePage('/safetyLeadership')
            else if(response.moduleReport == "Y")
              utils.movePage('/totalReport')
            else if(response.moduleBoard == "Y")
              utils.movePage('/myBoard')
            else
              utils.movePage('/empty')
          }
        }
      },
      (error) => {
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        if(snackText.value.includes('message.'))
          snackText.value = t(snackText.value)
        snackbar.value = true
      }
    )
  }
}

const onClickFindPassword = ()=>{
  if(utils.isEmpty(user.value.memberId)){
    snackText.value = t('message.enterIdAndRetry')
    snackbar.value = true
    return
  }
  dialogPasswordModel.value=true
}

const confirmPassword = async ()=>{
  try {
    const response:any = await AuthService.changePassword({memberId:user.value.memberId})
    if(response.success)
      snackText.value = t('message.changeSuccess')
    else
      snackText.value = response.message
    snackbar.value = true
  }
  catch(error){
    snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    snackbar.value = true
  }
}

</script>

<style lang="scss">
@media (max-width: 853px) {
  .container.login:has(input:focus) .foo-txt {
    opacity: 0;
    pointer-events: none;
  }
}
</style>
